import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12 sm:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12 lg:mb-16">
          <div>
            <h4 className="text-base font-bold mb-4 sm:mb-6">Access</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/for-individuals" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  For Individuals
                </Link>
              </li>
              <li>
                <Link to="/for-companies" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  For Companies
                </Link>
              </li>
              <li>
                <Link to="/access-levels" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Access Levels
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-base font-bold mb-4 sm:mb-6">System</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/how-it-works" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-base font-bold mb-4 sm:mb-6">Apply</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/apply" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Individual Access
                </Link>
              </li>
              <li>
                <Link to="/apply" className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Company Access
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-base font-bold mb-4 sm:mb-6">Halvera</h4>
            <p className="text-sm text-gray-400 leading-relaxed">
              Private continuity infrastructure for people who can't afford disruption.
            </p>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-center items-center gap-4">
          <p className="text-xs sm:text-sm text-gray-500 text-center">
            © 2024 Halvera. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
